import { CrewMember, RodRequest } from '@bechtel/types';

export enum CheckboxType {
  COMPLETED = 'COMPLETED',
  WELDED = 'WELDED',
}
export interface RodRequestProgressWeld {
  id: RodRequest['id'];
  requestNumber: RodRequest['requestNumber'];
  welds: RodRequest['welds'];
  stencils: RodRequest['stencils'];
}
export interface AssignedWeldSidesheetProps {
  welder: CrewMember;
  requestNumber?: string;
  onClose: () => void;
  onSave?: (rodRequests: RodRequest[]) => void;
  rodRequestProgressWeld?: RodRequestProgressWeld[];
}

export interface FormikState {
  welds: Record<
    string,
    {
      [CheckboxType.COMPLETED]: boolean;
      [CheckboxType.WELDED]: boolean;
      rodRequestId: string;
      weldId: string;
    }
  >;
  didNotWeld: Record<string, boolean>;
}
